import { useRef } from 'react'
import type { ReactNode } from 'react'

/**
 * A hidden file input and the way to open it: render `input` once, call `open` from a click. The chosen
 * files go to `onFiles`; choosing the same file again still counts.
 */
export const useFilePicker = ({
  accept,
  onFiles,
  multiple = true,
  disabled,
  testId
}: {
  accept: string
  onFiles: (files: File[]) => void
  multiple?: boolean
  disabled?: boolean
  testId?: string
}): { open: () => void; input: ReactNode } => {
  const ref = useRef<HTMLInputElement>(null)
  return {
    open: () => {
      if (!disabled) {
        ref.current?.click()
      }
    },
    input: (
      <input
        ref={ref}
        type="file"
        hidden
        multiple={multiple}
        accept={accept}
        disabled={disabled}
        aria-hidden
        tabIndex={-1}
        data-testid={testId}
        onClick={(event) => event.stopPropagation()}
        onChange={(event) => {
          const files = Array.from(event.target.files ?? [])
          event.target.value = ''
          if (!disabled && files.length > 0) {
            onFiles(files)
          }
        }}
      />
    )
  }
}
